import React from 'react';

// Shared Scouter ASCII "logo" used on both the landing product showcase and the
// developments card, so the two stay identical.
const SCOUTER_THEME = {
  '--scouter-green': '#79ffa3',
  '--scouter-green-dark': '#3ed97a',
  '--scouter-green-glow': 'rgba(121,255,163,0.12)',
  '--scouter-tan': '#c8b89a',
  '--scouter-beige': '#f0ece4',
  '--scouter-beige-mid': '#e8e0d4',
  '--scouter-wood-light': '#d4c4a8',
  '--scouter-wood-mid': '#b8a888',
  '--scouter-wood-dark': '#8c7a5c',
  '--scouter-ink': '#1a1a14',
  '--scouter-ink-mid': '#2e2e24',
  '--scouter-ink-soft': '#4a4a3c',
  '--scouter-text-muted': '#8a8a78',
  '--scouter-surface': '#f7f3ed',
  '--scouter-surface-dark': '#ede8df',
};

// Raw ASCII art string, shared with anything that needs to render the mark
// outside the styled `.scouter-placeholder` card (e.g. a section backdrop).
export const SCOUTER_ASCII_ART = String.raw`                      *
                      ###%
                      ###%        ###########%
                      #############################
                        ########%###         #%#######*
                               %#                 %######            ########%
                                ##*                  %#####           #######
                                 #%%                   =#####        #######
                                  ###                    %%##%    %###  %%%
                                   %%%                     ####%##%
                                    ###                     %###
                                     +##                 %##%%###
                                       ##             ##%#    ####
                                        ##         %###=       ####
                                         #%     ##%#*           ####
                                          ##+*####              %##%
                                          +####                 +###
                                       %### %#%                  ###%
                               #%=  #%#%=    #%#                 ###%
                            %########=        *#%                ###%
                         #%########%            ##               ####
                       #############             #%             %###
                         %########                #%            ####
                          #####                    ##+         %##%
                          %#                        %#*       %###+
                                                     #%#     %####
                                                      ###   ####+
                                                       %##%####
                                                         #####
                                                        ###%
                                                       ####
                                                       ###
                                                       %####*
                                                        #####
                                                           =`;

const ScouterAscii = ({ compact = false }) => (
  <div
    className={`scouter-placeholder${compact ? ' scouter-placeholder--compact' : ''}`}
    aria-label="Scouter placeholder logo"
    style={SCOUTER_THEME}
  >
    <pre className="scouter-placeholder__ascii">{SCOUTER_ASCII_ART}</pre>
  </div>
);

export default ScouterAscii;
